import React from "react";
import { Drawer, Flex, Menu, Space, Typography } from "@payping/web-components";
import { ArrowRightOutlined, FiDisc, FiLayers, FiShoppingCart, SettingOutlined } from "@payping/icons";
import { useAppTranslation } from "@/utils";
import { Link, useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import {
  bankInfoCardId,
  businessInfoCardId,
  customizeTerminalCardId,
  personalInfoCardId,
} from "@/assets/googleTrackIds";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";
import { coreAtom } from "@/core/state/root";

const firstUrlToSettingsAndProfileAtom = selectAtom(coreAtom, (val) => val.firstUrlToSettingsAndProfile);

const MobileSettingsMenu: React.FC = () => {
  const { t } = useAppTranslation();
  const [firstUrlToSettingsAndProfile] = useAtom(firstUrlToSettingsAndProfileAtom);

  const navigate = useNavigate();
  return (
    <Drawer
      placement={"bottom"}
      open={true}
      closable={false}
      height={"100%"}
      title={
        <Space>
          <ArrowRightOutlined width={14} onClick={() => navigate(firstUrlToSettingsAndProfile)} />
          {t("setting")}
        </Space>
      }
    >
      <Flex vertical={true}>
        <Typography.Title className={"!tw-mb-8 !tw-mt-5 tw-font-medium"} level={4}>
          {t("settings.businessSettings")}
        </Typography.Title>

        {/* < منو گزینه ها > */}
        <Menu className="tw-border-0" mode={"inline"}>
          {/* < درگاه پرداخت > */}
          <Menu.SubMenu
            icon={<FiDisc strokeWidth={1.5} width={14} />}
            key={"terminalPayment"}
            title={<Typography.Text>{t("settings.terminalPaymentInfo")}</Typography.Text>}
          >
            {/* < اطلاعات هویتی > */}
            <Menu.Item>
              <Flex justify={"space-between"}>
                <Link to={DashboardRoutes.settings.personal.root.url} data-google-track={personalInfoCardId}>
                  <Typography.Text>{t("profile.main.personal")}</Typography.Text>
                </Link>
              </Flex>
            </Menu.Item>

            {/* < کسب و کار > */}
            <Menu.Item>
              <Flex justify={"space-between"}>
                <Link to={DashboardRoutes.settings.business.root.url} data-google-track={businessInfoCardId}>
                  <Typography.Text>{t("profile.main.business")}</Typography.Text>
                </Link>
              </Flex>
            </Menu.Item>

            {/* <اطلاعات بانکی > */}
            <Menu.Item>
              <Flex justify={"space-between"}>
                <Link to={DashboardRoutes.settings.bank.root.url} data-google-track={bankInfoCardId}>
                  <Typography.Text>{t("profile.main.bank")}</Typography.Text>
                </Link>
              </Flex>
            </Menu.Item>
          </Menu.SubMenu>

          {/* < تنظیمات عمومی > */}
          <Menu.SubMenu icon={<SettingOutlined width={14} />} title={t("settings.menuItemGroups.commonSettings")}>
            {/* < ارتقا پلن > */}
            <Menu.Item>
              <Link to={DashboardRoutes.user.upgrade.url}>
                <Typography.Text>{t("settings.menuItems.upgragePanel")}</Typography.Text>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>

          {/* < پایانه های فروش > */}
          <Menu.Item icon={<FiLayers strokeWidth={1.5} width={14} />}>
            <Link to={DashboardRoutes.settings.terminal.url} data-google-track={customizeTerminalCardId}>
              <Typography.Text>{t("terminals.myTerminals")}</Typography.Text>
            </Link>
          </Menu.Item>

          {/* < فروشگاه > */}
          <Menu.Item icon={<FiShoppingCart strokeWidth={1.5} width={14} />}>
            <Link to={DashboardRoutes.settings.shop.url}>
              <Typography.Text>{t("settings.menuItems.shop")}</Typography.Text>
            </Link>
          </Menu.Item>
        </Menu>
      </Flex>
    </Drawer>
  );
};

export default MobileSettingsMenu;
